import { DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI } from '../../../types/default-cloud-graph-conversation-entity-ati';
import { DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI } from '../../../types/default-cloud-graph-message-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import {
	type TypeFilterValue3PEntities,
	TypeFilterValueKey,
} from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { SlackIcon, SlackIconBorderless, SlackSearchResultIcon } from './icon';

const getSlackTypeFilterConfig = () => {
	const typeFilter = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	// Always include Message
	typeFilter.set(TypeFilterValueKey.Message, {
		entities3P: DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
		subTypes3P: [],
	});

	typeFilter.set(TypeFilterValueKey.Conversation, {
		entities3P: DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
		subTypes3P: [],
	});

	return typeFilter;
};

export const slackConfig: ThirdPartyConfig = {
	displayName: 'Slack',
	id: 'slack',
	resourceType: ProductResourceTypes3P.Slack,
	icon: get3PLogo(SlackIcon, 'Slack', 'medium'),
	iconBorderless: get3PLogo(SlackIconBorderless, 'Slack', 'small'),
	searchResultIcon: get3PLogo(SlackSearchResultIcon, 'Slack', 'large'),
	integrationAri: 'ari:cloud:platform::integration/slack',
	get typeFilterConfig() {
		return getSlackTypeFilterConfig();
	},
	filters: ['lastUpdated', 'slackChannel'],
	requiresOauth: true,
	isEnabled: () => true,
};
